import { IsIn, IsOptional, IsUUID, ValidateIf } from 'class-validator';

export const LOT_STORAGE_SOURCES = [
  'MANUAL',
  'HISTORY_INGREDIENT',
  'HISTORY_NAME',
  'NAME_MATCH',
  'AI',
] as const;
export type LotStorageSourceValue = (typeof LOT_STORAGE_SOURCES)[number];

export class CreateLotStorageAssignmentDto {
  @IsUUID()
  lotId!: string;

  @ValidateIf((dto: CreateLotStorageAssignmentDto) => !dto.cleaningAreaId)
  @IsUUID()
  equipmentId?: string;

  @ValidateIf((dto: CreateLotStorageAssignmentDto) => !dto.equipmentId)
  @IsUUID()
  cleaningAreaId?: string;

  @IsOptional()
  @IsUUID()
  moveFromAssignmentId?: string;

  @IsOptional()
  @IsIn(LOT_STORAGE_SOURCES)
  source?: LotStorageSourceValue;
}
